import React from "react";
import { Form } from "react-bootstrap";

interface SearchBoxProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
}

const SearchBox: React.FC<SearchBoxProps> = ({ value, onChange, placeholder="Search" }) => {
  return (
    <div className="search-box" style={{ position: "relative" }}>
      <Form.Control
        type="text"
        className="search"
        placeholder={placeholder || "Search"}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        style={{
          paddingLeft: "35px", // space for search icon
          paddingRight: "35px", // space for clear icon
        }}
      />
      
      {/* Search Icon */}
      <i
        className="ri-search-line search-icon"
        style={{
          position: "absolute",
          left: "10px",
          top: "50%",
          transform: "translateY(-50%)",
          color: "#888",
        }}
      />

      {/* Clear Icon */}
      {value && (
        <i
          className="ri-close-circle-line"
          style={{
            position: "absolute",
            right: "10px",
            top: "50%",
            transform: "translateY(-50%)",
            cursor: "pointer",
            color: "#888",
          }}
          onClick={() => onChange("")}
        />
      )}
    </div>
  );
};

export default SearchBox;
